import Api from '@/services/Api'

export default {
  get (params) {
    return Api().get('estado-proceso', { params })
  },

  view (params) {
    return Api().get(`estado-proceso/${params.id}`)
  },

  viewVehicleLocationEstadoProceso (params) {
    return Api().get(`estado-proceso/${params.id}/view-location-estado-proceso`)
  },

  post (data) {
    return Api().post('estado-proceso', data)
  },

  put (data) {
    return Api().put(`estado-proceso/${data.id}`, data)
  },

  delete (id) {
    return Api().delete(`estado-proceso/${id}`)
  }
}
